import styled, { css } from 'styled-components';
import SectionContainer from '../../components/SectionContainer';

export const ParamsLine = styled.div`
  padding-top: 15px;
  color: ${({ theme }) => theme.black};

  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
`;

export const ParamsContainer = styled(SectionContainer)`
  align-items: flex-start;

  @media(min-width: 1024px) {
    max-width: 1440px;
    justify-content: space-between;
  }
`;

export const OptionsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const OptionsItem = styled.li`
  position: relative;
  margin-bottom: 15px;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ParamsOption = styled.button`
  margin: 0;
  padding: 13px 15px;

  @media(min-width: 400px) {
    padding: 10px 15px;
  }

  color: inherit;
  text-align: left;

  background-color: transparent;
  border: 1px solid #eeeeee;
  border-radius: 50px;
  outline: none;

  transition: border-color 0.3s, background-color 0.3s, color 0.3s;

  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.blue};
  }

  ${({ isActive, theme }) => isActive && css`
    color: ${theme.white};

    background-color: ${theme.blue};
    border-color: ${theme.blue};
  `}

  ${({ isOpened, theme }) => isOpened && css`
    color: #636363;

    background-color: ${theme.yellow};
    border-color: ${theme.yellow};

    &:hover {
      border-color: ${theme.yellow};
    }
  `}

  ${({ isInput }) => isInput && css`
    cursor: text;

    &:focus {
      color: ${({ theme }) => theme.blue};

      background-color: transparent;
    }
  `}
`;

export const CheckboxList = styled.ul`
  li:not(:last-child) {
    margin-bottom: 25px;
  }

  /* Scrollable on low-height devices so all options are reachable */
  @media (max-height: 700px) {
    max-height: min(50vh, 320px);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    padding-right: 4px;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
`;
